const CAP = {
  "title": "Capítulo 28 — Tarjeta SIM",
  "sections": [
    {
      "heading": "Resumen",
      "text": "Este capítulo (“Tarjeta SIM”) forma parte del Manual de Autoprotección en Blockchain. Proporciona prácticas accionables para reducir la superficie de ataque y mejorar tu higiene digital."
    },
    {
      "heading": "Puntos clave",
      "list": [
        "Buenas prácticas concretas para el día a día.",
        "Riesgos habituales y cómo mitigarlos.",
        "Checklist final para verificar antes/después."
      ]
    },
    {
      "heading": "Checklist",
      "list": [
        "Verifiqué fuentes y dominios oficiales.",
        "Usé 2FA/TOTP o llaves físicas cuando aplica.",
        "Mantuve mis claves/seed fuera de línea y seguras."
      ]
    }
  ]
};

export default CAP;
